<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part"><strong>FRIDAY</strong></h1>
<p class="date"><strong><em>May 2, 1902</em></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?4817da72